const HomeHeader = () => import('./components/TheHomeHeader.vue');
const AppBar = () => import('./components/TheAppBar.vue');
const HomeView = () => import('./views/HomeView.vue');
const Themen = () => import('./views/Themen.vue');
const Thema = () => import('./views/Thema.vue');
const Projekte = () => import('./views/Projekte.vue');
const ProjekteFormular = () => import('./views/ProjekteFormular.vue');
const Massnahmen = () => import('./views/Massnahmen.vue');
const Planungen = () => import('./views/Planungen.vue');
const PlanungForm = () => import('./views/PlanungForm.vue');
const Foerderungen = () => import('./views/Foerderungen.vue');
const Kontakt = () => import('./views/Kontakt.vue');
const Impressum = () => import('./views/Impressum.vue');
const Downloads = () => import('./views/Downloads.vue');
const Presse = () => import('./views/Presse.vue');
const Footer = () => import('./components/TheFooter.vue');

/** @type {Array<import("vue-router").RouteRecordRaw>} */
export default [
  { path: '/', redirect: 'home' },
  {
    path: '/home',
    components: {
      default: HomeView,
      HomeHeader,
      Footer
    }
  },
  {
    path: '/themen',
    components: {
      default: Themen,
      AppBar,
      Footer
    }
  },
  {
    path: '/thema/:thema',
    components: {
      default: Thema,
      AppBar,
      Footer
    }
  },
  {
    path: '/massnahmen/:thema?/:massnahmenid?',
    components: {
      default: Massnahmen,
      AppBar,
      Footer
    }
  },
  {
    path: '/projekte',
    components: {
      default: Projekte,
      AppBar,
      Footer
    }
  },
  {
    path: '/projekte/formular',
    components: {
      default: ProjekteFormular,
      AppBar,
      Footer
    }
  },
  {
    path: '/planungen',
    components: {
      default: Planungen,
      AppBar,
      Footer
    }
  },
  {
    path: '/planungen/formular/:modus?',
    components: {
      default: PlanungForm,
      AppBar,
      Footer
    }
  },
  {
    path: '/foerderungen',
    components: {
      default: Foerderungen,
      AppBar,
      Footer
    }
  },
  {
    path: '/kontakt',
    components: {
      default: Kontakt,
      AppBar,
      Footer
    }
  },
  {
    path: '/impressum',
    components: {
      default: Impressum,
      AppBar,
      Footer
    }
  },
  {
    path: '/downloads',
    components: {
      default: Downloads,
      AppBar,
      Footer
    }
  },
  {
    path: '/presse',
    components: {
      default: Presse,
      AppBar,
      Footer
    }
  }
];
